import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function ManagerSync() {
    const [msg, setMsg] = useState("");
    const [err, setErr] = useState("");
    const nav = useNavigate();

    return (
        <div className="card">
            <h1>Sync</h1>

            {err && <div className="alert alert--error">{err}</div>}
            {msg && <div className="alert alert--ok">{msg}</div>}

            <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
                <button className="btn" onClick={() => nav("/manager/admin/import")}>
                    Standings Import (JSON)
                </button>
            </div>

            <p style={{ opacity: 0.7, marginTop: 12 }}>
                Hinweis: Reko Sync kommt, sobald der Backend Endpoint existiert.
            </p>
        </div>
    );
}